var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEnergyEconomy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5602 8.65992C18.4695 12.7568 16.2439 17.4493 15.1675 19.2798C15.0097 19.5358 14.7976 19.7543 14.5464 19.92C14.295 20.0855 14.0106 20.1943 13.7129 20.2385C11.6036 20.6018 6.35247 21.0086 3.53052 16.9117C0.752201 13.0473 0.86857 6.24831 1.11585 3.0086C1.1256 2.76724 1.1926 2.53163 1.31136 2.32118C1.43011 2.11074 1.5972 1.93146 1.79888 1.79812C2.00057 1.66478 2.23107 1.58119 2.47143 1.55422C2.71179 1.52725 2.95513 1.55767 3.18141 1.64299C6.30884 2.54372 12.8255 4.79553 15.5602 8.65992Z",
    stroke: "currentColor",
    strokeWidth: 1.63582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75586 7.30884C9.0877 11.2303 12.012 15.4796 14.4836 19.9916",
    stroke: "currentColor",
    strokeWidth: 1.63582,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergyEconomy);
export default __webpack_public_path__ + "static/media/icon-energy-economy.eb6ef774af7e6ce49e1d1643ade33786.svg";
export { ForwardRef as ReactComponent };